// extracted by mini-css-extract-plugin
export var avatarContainer = "_8r-0";
export var avatarTypingWave = "_8r-i";
export var gray = "_8r-f";
export var green = "_8r-c";
export var icon = "_8r-9";
export var image = "_8r-1";
export var lg = "_8r-6";
export var md = "_8r-5";
export var presenceDot = "_8r-b";
export var red = "_8r-d";
export var sm = "_8r-4";
export var status = "_8r-a";
export var typingDot = "_8r-h";
export var typingPill = "_8r-g";
export var xl = "_8r-7";
export var xs = "_8r-3";
export var xxl = "_8r-8";
export var xxs = "_8r-2";
export var yellow = "_8r-e";